module.exports = __webpack_public_path__ + "static/media/venturex-eat.b9cf1324.jpg";